import { useTranslation } from "@/hooks/useTranslation"

export const ProcessingMeta = () => {
  const { t } = useTranslation()

  return <div>{t("issue.processing.description")}</div>
}
